import React from 'react';

interface IIconCreditCardProps {
  fill?: string;
  [key: string]: any;
}

const IconCreditCard: React.FC<IIconCreditCardProps> = ({ fill = '#896c6c', ...props }) => (
  <svg x="0px" y="0px" viewBox="0 0 28 21" {...props}>
    <title>Credit Card</title>
    <g>
      <g transform="translate(-4.000000, -7.000000)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={fill}
          d="M29.5,7H6.5C5.1,7,4,8.1,4,9.4v16.1C4,26.9,5.1,28,6.5,28h23.1c1.4,0,2.5-1.1,2.5-2.5V9.4
        C32,8.1,30.9,7,29.5,7z M30.6,25.5c0,0.6-0.5,1.1-1.1,1.1H6.5c-0.6,0-1.1-0.5-1.1-1.1V15.2h25.2V25.5z M30.6,13.8H5.4V9.4
        c0-0.6,0.5-1.1,1.1-1.1h23.1c0.6,0,1.1,0.5,1.1,1.1V13.8z M13.3,19.9H7.9v1.4h5.4V19.9z M24.5,19.9h-9.3v1.4h9.3V19.9z"
        />
      </g>
    </g>
  </svg>
);

export default IconCreditCard;
